import LogoComponent from './Logo.component';

export default function LogoContainer() {
  return (
    <LogoComponent />
  );
}
